export default __webpack_public_path__ + "static/media/march2025-thumbnail.eb28848a.jpeg";